export default __webpack_public_path__ + "static/media/III-2019.147de4d5.pdf";